import { createSlice } from "@reduxjs/toolkit";
import request from "../../service";
import Exported from "../../service/endpoints";

const initialState ={
    microAppList : [],
    recentActivity: {}
}
export const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        saveMicroAppList : (state, action) =>{
            state.microAppList = action.payload
        },
        saveRecentActivity : (state, action) =>{
            state.recentActivity = action.payload
        },
    },
});

export const createUserSlot = (data) => {
    return request({
        url: Exported.Endpoints.createUserSlot,
        method: Exported.APIMethods.POST,
        data,
    });
};

export const { saveMicroAppList, saveRecentActivity } = adminSlice.actions;